import { render, staticRenderFns } from "./dropdownChoosedStatusForPaymentArchive.vue?vue&type=template&id=135df924&scoped=true"
import script from "./dropdownChoosedStatusForPaymentArchive.vue?vue&type=script&lang=js"
export * from "./dropdownChoosedStatusForPaymentArchive.vue?vue&type=script&lang=js"
import style0 from "./dropdownChoosedStatusForPaymentArchive.vue?vue&type=style&index=0&id=135df924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135df924",
  null
  
)

export default component.exports